import { processJcamp, serializeNmriumState, CURRENT_EXPORT_VERSION, } from 'nmr-load-save';
import * as Datum1D from './data1d/Spectrum1D';
import * as Datum2D from './data2d/Spectrum2D';
import * as Molecule from './molecules/Molecule';
export var DataExportOptions;
(function (DataExportOptions) {
    DataExportOptions["ROW_DATA"] = "ROW_DATA";
    DataExportOptions["DATA_SOURCE"] = "DATA_SOURCE";
    DataExportOptions["NO_DATA"] = "NO_DATA";
})(DataExportOptions || (DataExportOptions = {}));
function getData(datum, usedColors) {
    const dimension = datum.info.dimension;
    if (dimension === 1) {
        return Datum1D.initiateDatum1D(datum, { usedColors });
    }
    else if (dimension === 2) {
        return Datum2D.initiateDatum2D(datum, { usedColors });
    }
}
export function addJcamp(output, jcamp, options, usedColors) {
    options = options || {};
    const name = options?.info?.name;
    const { spectra: spectraIn } = processJcamp(jcamp, {
        name,
        converter: {
            keepRecordsRegExp: /.*/,
            profiling: true,
        },
    });
    if (spectraIn.length === 0)
        return;
    const spectra = [];
    for (let spectrum of spectraIn) {
        const data = getData(spectrum, usedColors);
        if (!data)
            continue;
        spectra.push(data);
    }
    output.push(...spectra);
}
/**
 *
 * @param {object} state
 */
export function toJSON(state, preferencesState, options = {}) {
    const { source, data = [], molecules: mols = [], correlations = {}, actionType = '', } = state;
    const { dataType = 'ROW_DATA', view = false, settings = false, serialize = true, exportTarget = 'nmrium', } = options;
    const molecules = mols.map((mol) => Molecule.toJSON(mol));
    const nmriumState = {
        version: CURRENT_EXPORT_VERSION,
        data: {
            ...(exportTarget === 'onChange' ? { actionType } : {}),
            source,
            spectra: data,
            molecules,
            correlations,
        },
        view: state.view,
        settings: preferencesState.current,
    };
    if (!serialize) {
        return nmriumState;
    }
    else {
        const includeData = dataType === 'ROW_DATA'
            ? 'rawData'
            : dataType === 'NO_DATA'
                ? 'noData'
                : 'dataSource';
        return serializeNmriumState(nmriumState, {
            includeData,
            includeSettings: settings,
            includeView: view,
        });
    }
}
